import React from 'react';
import { Route, Switch } from 'react-router-dom';

import firmMap, { List } from './List';
import { AddEditFirm } from './AddEditFirm';
import { ViewFirm } from './ViewFirm';
import ProtectedRoute from '../PrivateRoute';

function Firms({ match }) {
    const { path } = match;

    return (
        <Switch>
            <ProtectedRoute exact path={path} component={firmMap} />
            <Route path={`${path}/add`} component={AddEditFirm} />
            <Route path={`${path}/edit/:id`} component={AddEditFirm} />
            <Route path={`${path}/view/:id`} component={ViewFirm} />
        </Switch>
    );
}

export { Firms };